import { H1, H3 } from '~/shared/Typography';
import { VStack } from 'native-base';
import { useGetMember, useSpringBigStore } from '@springbig/shared';
import PlanCard from './components/PlanCard';
import useSubscriptionPlansHelpers from '~/pages/subscriptions/hooks/useSubscriptionPlansHelpers';
import React, { useEffect } from 'react';
import { Section } from '~/shared/Theme';

const SubscriptionsScreen = () => {

    const {
        plans,
        subscribedPlans,
    } = useSubscriptionPlansHelpers();

    const { member } = useSpringBigStore();

    const { refetch: refreshMember } = useGetMember();

    useEffect(() => {

        refreshMember();
    }, []);

    if ((member && !member.subscriptions_enabled) || (!plans && !subscribedPlans)) {
        return (
            <VStack
                justifyContent={'center'}
                alignItems={'center'}
                flex={1}
            >
                <H1 text={'subscriptions.no_plan_message'} />
            </VStack>
        );
    }

    return (
        <Section>
            <VStack space={4} p={4}>
                { member && !!member.subscriptions_enabled && subscribedPlans && subscribedPlans.length > 0 &&
                    <VStack space={4}>
                        <H3 textAlign={'center'} text={'subscriptions.active_section'} />
                        { subscribedPlans?.map((plan, index) => {

                            return <PlanCard plan={plan} key={index} status={'active'} />;
                        })}
                    </VStack>
                }
                { member && !!member.subscriptions_enabled && plans && plans.length > 0 &&
                    <VStack space={4}>
                        <H3 textAlign={'center'} text={'subscriptions.explore_section'} />
                        { plans?.map((plan, index) => {

                            return <PlanCard plan={plan} key={index} status={'inactive'} />;
                        })}
                    </VStack>
                }
            </VStack>
        </Section>
    );
};

export default SubscriptionsScreen;
